import React, { FC } from 'react'
import classNames from 'classnames'
import { Box, createStyles, makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { LocationPinIcon } from 'transfix-icons'
import { Button } from 'transfix-ui'
import { useBrowserLocationContext } from '../context/BrowserLocationContext'

const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      textAlign: 'left',
      paddingLeft: theme.spacing(3),
    },
    buttonText: {
      color: brandColors.coolGray5,
    },
    button: {
      paddingTop: 0,
    },
    buttonTextBanner: {
      color: brandColors.white,
    },
    span: {
      fontSize: '12px',
    },
    rootBanner: {
      textAlign: 'left',
      padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
      color: brandColors.white,
      backgroundColor: brandColors.transparent,
      borderColor: brandColors.transparent,
      '&:hover, &:active, &:focus': {
        color: brandColors.black,
        backgroundColor: brandColors.white,
        borderColor: brandColors.transparent,
        opacity: '0.7',
        '&:hover': {
          color: brandColors.black,
          backgroundColor: brandColors.white,
          borderColor: brandColors.transparent,
          opacity: '0.7',
        },
      },
    },
  })
)

interface ISetBrowserLocationButtonProps {
  /**
   * On button click
   */
  onClick: () => void
  variant: 'loadBanner' | 'loadSearch'
}

export const SetBrowserLocationButton: FC<ISetBrowserLocationButtonProps> = ({
  onClick,
  variant,
}) => {
  const classes = useStyles()
  const { browserLocation, hasLocationName } = useBrowserLocationContext()
  const { cityName, stateCode } = browserLocation || {}
  const loadBanner = variant === 'loadBanner'

  const classText = classNames({
    [classes.buttonTextBanner]: loadBanner,
    [classes.buttonText]: !loadBanner,
  })
  const root = classNames({ [classes.rootBanner]: loadBanner }, { [classes.root]: !loadBanner })

  return (
    <Button
      data-test='browser-location-button'
      color={loadBanner ? undefined : 'tertiary'}
      className={root}
      onClick={onClick}>
      <div>
        {!loadBanner && (
          <Typography variant='caption' className={classText}>
            My location
          </Typography>
        )}
        {loadBanner && <span className={classes.span}>My location</span>}
        <Box display='flex' flexDirection='row' alignContent='center'>
          <div>
            <LocationPinIcon size='large' />
          </div>
          <Box pl={0.5}>{hasLocationName ? `${cityName}, ${stateCode}` : 'Set Location'}</Box>
        </Box>
      </div>
    </Button>
  )
}
